import React, { useEffect } from "react";
import { Button } from "@mui/material";
import FingerprintIcon from "@mui/icons-material/Fingerprint";

import FullLogoPrimary from "@/assets/logos/full-logo-primary.png";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import pxToRem from "@/themes/functions/pxToRem";

interface BiometricUnlockFormProps {
  onUnlock: () => void;
  onFallbackLogin: () => void;
  isAuthenticating?: boolean;
}

const BiometricUnlockForm: React.FC<BiometricUnlockFormProps> = ({
  onUnlock,
  onFallbackLogin,
  isAuthenticating = false,
}) => {
  // Solicita desbloqueio automaticamente ao montar
  useEffect(() => {
    onUnlock();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MDBox width={"70%"} maxWidth={pxToRem(400)}>
      <MDBox mb={2}>
        <img src={FullLogoPrimary} height={64} alt="Logo" />
      </MDBox>

      <MDBox mb={1}>
        <MDTypography variant="h3" color="white" fontWeight={"bold"}>
          App bloqueado
        </MDTypography>

        <MDTypography variant="body2" color="white" mt={0.5}>
          Use sua biometria para desbloquear o acesso
        </MDTypography>
      </MDBox>

      <MDBox
        pt={4}
        pb={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={2}
      >
        <Button
          variant="contained"
          size="large"
          fullWidth
          startIcon={<FingerprintIcon />}
          onClick={onUnlock}
          disabled={isAuthenticating}
          sx={{
            bgcolor: "white",
            color: "primary.main",
            borderRadius: "50px",
            fontWeight: "bold",
            textTransform: "uppercase",
            py: 1.2,
            "&:hover": {
              bgcolor: "rgba(255,255,255,0.9)",
            },
            "&.Mui-disabled": {
              bgcolor: "rgba(255,255,255,0.5)",
            },
          }}
        >
          {isAuthenticating ? "Verificando..." : "Desbloquear"}
        </Button>

        <MDTypography
          variant="button"
          fontWeight="regular"
          color="white"
          onClick={onFallbackLogin}
          sx={{
            cursor: "pointer",
            userSelect: "none",
            mt: 2,
            textDecoration: "underline",
            "&:hover": { opacity: 0.8 },
          }}
        >
          Entrar com senha
        </MDTypography>
      </MDBox>
    </MDBox>
  );
};

export default BiometricUnlockForm;
